import React, { useId } from 'react';

import { cn, Input, Label } from '@src/components/ui';


/**
 * Base text field — label above, input, helper/error line below.
 * Receives RHF field props (value/onChange/onBlur/name/ref) plus
 * `error` (bool) and `helperText` from the generic form wrapper.
 */
const TextField = React.forwardRef((props, ref) => {
  const {
    label,
    value = '',
    error = false,
    helperText = ' ',
    className,
    leading = null,
    trailing = null,
    ...restProps
  } = props;

  const generatedId = useId();
  const id = restProps.id || generatedId;

  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {label
        ? (
          <Label htmlFor={id}>{label}</Label>
        )
        : null}

      <Input
        ref={ref}
        id={id}
        value={value}
        invalid={error}
        leading={leading}
        trailing={trailing}
        {...restProps}
      />

      <p className={cn('min-h-4 text-xs', error ? 'text-danger' : 'text-ink-subtle')}>
        {helperText}
      </p>
    </div>
  );
});

TextField.displayName = 'TextField';
export default TextField;
